<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-number [value]="all" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="50"></app-number>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">

  <app-theme-option-layout-padding-top [themeOptions]="themeOptions"></app-theme-option-layout-padding-top>
  <app-theme-option-layout-padding-left [themeOptions]="themeOptions"></app-theme-option-layout-padding-left>
  <app-theme-option-layout-padding-right [themeOptions]="themeOptions"></app-theme-option-layout-padding-right>
  <app-theme-option-layout-padding-bottom [themeOptions]="themeOptions"></app-theme-option-layout-padding-bottom>

</div>